// The only way a V2 component passes React's style prop (plan §1.11): --mc-* custom properties whose values are a
// number, a percentage or a design-system token, read by the component's CSS with a fallback, for example
// var(--mc-hue, var(--p-grey)). Anything else throws, so a colour or a length can never enter through style.

import type { CSSProperties } from "react";

export type McVarName = `--mc-${string}`;
export type McVarValue = number | `${number}%` | `var(--${string})`;

const PERCENT = /^-?\d*\.?\d+%$/;
const TOKEN = /^var\(--[a-zA-Z0-9-]+\)$/;

export function vars(values: Readonly<Partial<Record<McVarName, McVarValue | undefined>>>): CSSProperties {
  const style: Record<string, string | number> = {};
  for (const [name, value] of Object.entries(values)) {
    if (!name.startsWith("--mc-")) throw new Error(`vars: "${name}" is not an --mc-* property`);
    if (value === undefined) continue;
    if (typeof value === "number") {
      if (!Number.isFinite(value)) throw new Error(`vars: ${name} is not a finite number`);
    } else if (!PERCENT.test(value) && !TOKEN.test(value)) {
      throw new Error(`vars: ${name} = "${value}" is not a number, a percentage or a token var()`);
    }
    style[name] = value;
  }
  return style as CSSProperties;
}
